



























































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import { mixins } from "vue-class-component";
import ImportPage from "@/lib/import-page";
import PageRequest from "@/store/entities/page-request";
import ListMixin from "@/components/mixin/list-mixin";
import _ from "lodash";
import { Message } from "iview";

class PageImportTransferOrderRequest extends PageRequest {
  toFileId: number;
  clientCode: string;
}
@Component({
  components: {},
})
export default class ImportTransferOrder extends mixins(
  ListMixin,
  AbpBase,
  ImportPage
) {
  importPageName = "TransferOrder";
  namespace = "transferOrderImport";
  pagerequest: PageImportTransferOrderRequest =
    new PageImportTransferOrderRequest();

  //filters
  current: number = 0;
  transferOrderFileId: number = 0;
  spinShow: boolean = false;
  clients = [];

  get store() {
    return this.$store.state.transferOrderImport;
  }
  isClient() {
    return this.$store.state.session.client != null;
  }
  get client() {
    return this.$store.state.session.client;
  }
  async getClients() {
    await this.$store
      .dispatch({
        type: "client/getListForSelect",
      })
      .then(() => {
        var re = this.$store.state.client.clientsForSelect;
        this.clients = re;
      });
  }
  get countItems() {
    return this.$store.state.transferOrderImport.countItems;
  }
  get countImportedItems() {
    return this.$store.state.transferOrderImport.countImportedItems;
  }
  preGetPage() {
    this.pagerequest.toFileId = this.transferOrderFileId;
  }
  activeStep(next: boolean) {
    if (next && this.current < 1) {
      this.current++;
    }
    if (!next && this.current > 0) {
      this.current--;
    }
  }
  nextStep() {
    this.activeStep(true);
  }
  backStep() {
    this.activeStep(false);
  }
  async exportToExcel() {
    await this.$store.dispatch({
      type: "transferOrderImport/export",
      data: this.transferOrderFileId,
    });
  }
  columns = [
    {
      title: this.L("ErrorMsg"),
      width: 200,
      fixed: "left",
      slot: "errorMessage",
    },
    {
      title: this.L("Code"),
      width: 150,
      key: "code",
    },
    {
      title: this.L("SrcWarehouse"),
      width: 150,
      key: "srcWarehouseCode",
    },
    {
      title: this.L("DstWarehouse"),
      width: 150,
      key: "dstWarehouseCode",
    },
    {
      title: this.L("AssetTypeCode"),
      width: 100,
      key: "line_AssetTypeCode",
    },
    {
      title: this.L("ConditionTypeCode"),
      width: 100,
      key: "line_ConditionTypeCode",
    },
    {
      title: this.L("SKU"),
      width: 150,
      key: "line_SKU",
    },
    {
      title: this.L("Qty"),
      width: 100,
      key: "line_Qty",
      align: "right",
      render: (h: any, params: any) => {
        return h("span", Util.toViewNumberString(params.row.line_Qty));
      },
    },
    {
      title: this.L("ProductType"),
      width: 150,
      key: "productType",
    },
    {
      title: this.L("IsImported"),
      width: 80,
      fixed: "right",
      key: "isImported",
      align: "center",
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Icon",
            {
              props: {
                size: 36,
                type: params.row.isImported
                  ? "md-checkmark-circle"
                  : "md-close-circle",
              },
            },
            ""
          ),
        ]);
      },
    },
  ];

  async created() {
    await this.getClients();

    if (!this.checkSignalConnected()) return;

    if (Util.abp.signalr && Util.abp.signalr.hubs.common.state == 1) {
      Util.abp.signalr.hubs.common.on("Import.To", (notification) => {
        this.processNotifierImportTransferOrder(notification);
      });
    } else {
      abp.event.on("abp.signalr.connected", () => {
        Util.abp.signalr.hubs.common.on("Import.To", (notification) => {
          this.processNotifierImportTransferOrder(notification);
        });
      });
    }
  }
  processNotifierImportTransferOrder(notification: any) {
    if (notification.toFileId == this.transferOrderFileId) {
      this.$store.commit({
        type: "transferOrderImport/processNotifier",
        data: notification,
      });
    }
  }
  handleBeforeUpload(file) {
    if (this.isClient()) {
      this.pagerequest.clientCode = this.client.code;
    } else if (
      _.isNull(this.pagerequest.clientCode) ||
      _.isUndefined(this.pagerequest.clientCode)
    ) {
      this.$Message.error("Client is require");
      return;
    }

    const fileExt = file.name.split(".").pop().toLocaleLowerCase();
    if (fileExt === "xlsx" || fileExt === "xls") {
      let data = new FormData();
      data.append("file", file);
      data.append("clientCode", this.pagerequest.clientCode);
      this.spinShow = true;
      try {
        this.$store
          .dispatch("transferOrderImport/importTos", data)
          .then((res) => {
            this.resetList();
            this.resetCountItems();
            this.resetCountImportedItems();
            this.activeStep(true);
            this.spinShow = false;
            this.transferOrderFileId = res;
          })
          .catch((error) => {
            this.spinShow = false;
          });
      } catch (error) {
        this.spinShow = false;
      }
    }
    return false;
  }
}
